export default __webpack_public_path__ + "fighter-jet-silhouette.png";